import React, {useEffect} from 'react';

import Header from './Layout/Header'
import {BrowserRouter, Routes, Route} from "react-router-dom";

import Home from './Components/0Home';
import Information from './Components/1Information';
import PersonalDetails from './Components/2PersonalDetails';
import Family from './Components/3Family';
import FamilyPartner from './Components/3FamilyPartner';
import FamilyChildren from './Components/3FamilyChildren';
import FamilyParent from "./Components/3FamilyParent";
import FamilyOther from  "./Components/3FamilyOther"
import Job from './Components/4Job'
import JobEmployee from './Components/4JobEmployee'
import JobIndependant from './Components/4JobIndependant'
import JobStudent from "./Components/4JobStudent";
import Circumstances from './Components/5Circumstances';
import Witnesses from './Components/5Witnesses';
import Consequences from './Components/6Consequences';
import Physical from './Components/6Physical'
import Physicald from './Components/6Physicald'
import Intervention from './Components/7Intervention';
import Remark from './Components/8Remark';
import Final from './Components/9Final'
import JobPartnerEmployee from "./Components/4JobPartnerEmployee";
import JobPartnerIndependant from "./Components/4JobPartnerIndependant";
import JobPartnerStudent from "./Components/4JobPartnerStudent";
import JobPartner from "./Components/4JobPartner";

import './styles/App.scss'

import {useTranslation} from "react-i18next";


function App() {

    const { i18n } = useTranslation();
    useEffect(() => {
        window.scrollTo(0, 0)
        const dead = localStorage.getItem('isDead')
        //console.log(dead)
        let d = dead === "true"
        if (d) {
            document.getElementById('themeswitcher').setAttribute('href', process.env.PUBLIC_URL+'/styles/dead.css');

        }else{
            document.getElementById('themeswitcher').setAttribute('href', process.env.PUBLIC_URL+'/styles/injured.css');
        }

        document.body.classList.add('home');
        let lang = ((window.location.href.indexOf('/fr') > -1 ) && 'fr') ||
            (( window.location.href.indexOf('/nl') > -1 ) && 'nl') ||
            (( window.location.href.indexOf('/de')  > -1 ) && 'de') ||
            (( window.location.href.indexOf('/en')  > -1  ) && 'en')
        const Switch = () =>{
            //console.log(!!lang)
            if (!!lang){
                i18n.changeLanguage(lang);
            }else{
                window.location.replace('./nl')
            }
        }
        Switch()
    }, [])


    return (
        <BrowserRouter  basename={'/accidentinfo'}>
            <Routes>
                    <Route path={":lang"} element={<Header />}>
                        <Route exact path={""} element={<Home />}  />
                        <Route exact path={"information"} element={<Information />}  />
                        <Route exact path={"personal-details"} element={<PersonalDetails />}  />
                        <Route exact path={"family"} element={<Family />}  />
                        <Route exact path={"family-partner"} element={<FamilyPartner />}  />
                        <Route exact path={"family-children"} element={<FamilyChildren />}  />
                        <Route exact path={"family-parents"} element={<FamilyParent />}  />
                        <Route exact path={"family-other"} element={<FamilyOther />}  />
                        <Route exact path={"job"} element={<Job />}  />
                        <Route exact path={"job-employee"} element={<JobEmployee />}  />
                        <Route exact path={"job-independant"} element={<JobIndependant />}  />
                        <Route exact path={"job-student"} element={<JobStudent />}  />
                        <Route exact path={"job-partner"} element={<JobPartner />}  />
                        <Route exact path={"job-partner-employee"} element={<JobPartnerEmployee />}  />
                        <Route exact path={"job-partner-independant"} element={<JobPartnerIndependant />}  />
                        <Route exact path={"job-partner-student"} element={<JobPartnerStudent />}  />
                        <Route exact path={"circumstances"} element={<Circumstances />}  />
                        <Route exact path={"witnesses"} element={<Witnesses />}  />
                        <Route exact path={"consequences"} element={<Consequences />}  />
                        <Route exact path={"physical"} element={<Physical />}  />
                        <Route exact path={"physicald"} element={<Physicald />}  />
                        <Route exact path={"intervention"} element={<Intervention />}  />
                        <Route exact path={"remark"} element={<Remark />}  />
                        <Route exact path={"final"} element={<Final />}  />
                    </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
